import React, { type FC } from "react";
import { MFEPageProvider } from "@edreamsodigeo/frontend-commons-build/macro";
import { BasePathProvider } from "@edreamsodigeo/frontend-core";

import { VersionedThemeVersionProvider } from "~/providers";
import Root from "./Root";

const RootPageMFE: FC = () => {
  return (
    <MFEPageProvider>
      <VersionedThemeVersionProvider>
        <BasePathProvider basePath="/travel/accommodation/">
          <Root />
        </BasePathProvider>
      </VersionedThemeVersionProvider>
    </MFEPageProvider>
  );
};

export default RootPageMFE;
